


const labels=[
    {hash: "#/selectgroup", label: "Submit Experiment - Select Owner"},
    {hash: "#/project", label: "Project Info"},
    {hash: "#/your_datamanagement", label: "Your Data Management"},
    {hash: "#/experimentsubmissionchoices", label: "Submit Experiments"},
    {hash: "#/experimenttemplatesubmission", label: "Submit Experiments"},
    {hash: "#/submitexperiments", label: "Submit Experiment"},
    {hash: "#/selectexperiments", label: "Submit Files - Select Experiments"},
    {hash: "#/submitfiles", label: "Submit Files"},
    {hash: "#/experimentsubmitted", label: "Submitted Experiments- Summary"},
    {hash: "#/filesubmitted", label: "Submitted Files - Summary"},
    {hash: "#/experimentanalysisstatus", label: "Experiment Analysis Status"},
    {hash: "#/taggedvariants", label: "Tagged Variants"},
    {hash: "#/staticdataaccess", label: "Statistics Data Access"},
    {hash: "#/experimentinfo", label: "Experiment info"},
    {hash: "#/experiments", label: "Experiment View"},
    {hash: "#/files", label: "Files View"},
    {hash: "#/admin/aspera", label: "Aspera Files"},
    {hash: "#/admin/experimentprogress", label: "Experiment Progress View"}

];



function getPath(hash){


    let found = labels.find(x => x.hash=== hash);
    if(found){
        return found.label;
    }
    else{
        let search = labels.find(x => hash.includes(x.hash));
        if(search!== undefined)
        {
            return search.label;
        }
        else{
            return null;
        }
    }





}



export default getPath;
